import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

import { bind } from '@recruitee/utils';

@Pipe({
  name: 'fnBind',
  standalone: true,
})
export class FnBindPipe implements PipeTransform {
  public transform<T extends (...args: any[]) => any>(fn: T, thisArg: any, ...args: Parameters<T>) {
    return bind(fn, thisArg, ...args);
  }
}
